// extracted by mini-css-extract-plugin
export default {"header":"_E_35"};